export default __webpack_public_path__ + "static/media/Nineth.e3bf4597.png";